// @ts-check
/* CUSTOM: Sticky header som PRYA (12/10 2026) – se custom-navigation.css.
   Måler headerens højde og lægger den i --custom-header-height på <html>, så andre sticky elementer
   (fx produktsidens kolonne) kan stå under headeren i stedet for at glide ind bag den. */
(function () {
  const header = document.querySelector('[data-section-type="header"] .site-header');
  if (!(header instanceof HTMLElement)) return;

  function update() {
    document.documentElement.style.setProperty('--custom-header-height', /** @type {HTMLElement} */ (header).offsetHeight + 'px');
  }

  update();
  if ('ResizeObserver' in window) {
    new ResizeObserver(update).observe(header);
  } else {
    window.addEventListener('resize', update);
  }
})();
